import { render, staticRenderFns } from "./NhBackToTop.vue?vue&type=template&id=619db18a"
import script from "./NhBackToTop.vue?vue&type=script&lang=js"
export * from "./NhBackToTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports